import React from 'react';
import { useState, useEffect } from 'react';
import Header from '@component/Header';
import MegaNav from '@component/MegaNav';
import WBRString from '@component/WbrString';
import { RoutableLink } from '../../react/RoutableLink';
import EditableLink from '../../react/EditableLink';
import { Text, Image, withSitecoreContext, RichText } from '@sitecore-jss/sitecore-jss-react';
import homeIcon from './static/homeicon.svg';
import CoveoSearch from '../CoveoSearch';
import i18n from 'i18next';

const getLinkList = (link) => {
  const rightFolder = link.fields?.children?.find((e) => e.name.toLowerCase() === 'right');
  const subNavLinkListTemplateId = '9e9283a5-90d7-43d3-88d8-5b10229a8b6a';
  const linkListFolder = rightFolder?.fields?.children?.find((e) => e.templateId === subNavLinkListTemplateId);
  const linkList = [];
  linkListFolder?.fields?.children?.map((l, i) => {
    linkList.push(
      <>
        <RoutableLink field={l.fields?.link} key={i} useATag={true}>
          <WBRString tag="span">
            <Text field={l.fields?.linktext} />
          </WBRString>
        </RoutableLink>
      </>
    );
  });
  return linkList;
};

const getLinkListTitle = (link) => {
  const rightFolder = link.fields?.children?.find((e) => e.name.toLowerCase() === 'right');
  const subNavLinkListTemplateId = '9e9283a5-90d7-43d3-88d8-5b10229a8b6a';
  const linkListFolder = rightFolder?.fields?.children?.find((e) => e.templateId === subNavLinkListTemplateId);
  return (
    <>
      <WBRString tag="span">
        <Text field={linkListFolder?.fields?.title} />
      </WBRString>
    </>
  );
};

const getLinkRichtext = (link) => {
  const rightFolder = link.fields?.children?.find((e) => e.name.toLowerCase() === 'right');
  const subNavLinkTextTemplateId = 'e3fe602d-3bfc-45b5-b1e4-b5b0489c8de7';
  const linkListFolder = rightFolder?.fields?.children?.find((e) => e.templateId === subNavLinkTextTemplateId);
  return (
    <>
      <Text field={linkListFolder?.fields?.richTextMenu?.value} />
    </>
  );
};

const getMenuCards = (link, folderName, buttonClass) => {
  const folder = link.fields?.children?.find((e) => e.name.toLowerCase() === folderName);
  const subNavLinkTemplateId = '1eb2ad60-09cc-41b6-a44e-1f7f4493e7d0';
  const subNavLinks = folder?.fields?.children?.filter((e) => e.templateId === subNavLinkTemplateId);
  const linkList = [];
  subNavLinks?.map((l, i) => {
    linkList.push({
      title: <Text field={l.fields?.title} />,
      description: <RichText field={l.fields?.copy} />,
      link: (
        <>
          <RoutableLink field={l.fields?.link} key={i} className={buttonClass} useATag={true}>
            <WBRString tag="span">{getLinkText(l.fields?.linktextoverride)}</WBRString>
          </RoutableLink>
        </>
      ),
    });
  });

  return linkList;
};

const getLinkText = (linktext) => {
  if (linktext?.value === '') return i18n.t('button/view') || 'View';
  return <Text field={linktext} />;
};

const getLanguageLink = (linkField) => {
  if (typeof window !== 'undefined') {
    let completeCurrentPath = window.location.href.replace(window.location.origin, '');
    let destinationLanguage = linkField.value.href + '/';
    let newPath = getLinkPath(completeCurrentPath, destinationLanguage);
    let languageLink = structuredClone(linkField);
    languageLink.value.href = newPath;
    languageLink.value.url = newPath;
    return languageLink;
  }
  return linkField;
};

const getLinkPath = (completeCurrentPath, destinationLanguage) => {
  //possible url patterns
  //[host]/
  //[host]/en-us
  //[host]/en-us/some-other-path

  //Looking for the pattern [protocol]://[host]/ab-cd/
  const patternWithBESlash = /\/([\w]{2})-([\w]{2})\//;
  //Looking for the pattern [protocol]://[host]/ab-cd
  const patternWithBSlashOnly = /\/([\w]{2})-([\w]{2})\b/g;

  var newPath = '';

  if (completeCurrentPath === '') {
    newPath = destinationLanguage;
  } else if (completeCurrentPath === '/') {
    newPath = destinationLanguage.slice(1);
  } else if (completeCurrentPath.search(patternWithBESlash) > -1) {
    newPath = completeCurrentPath.replace(patternWithBESlash, destinationLanguage);
  } else if (completeCurrentPath.search(patternWithBSlashOnly) > -1) {
    newPath = completeCurrentPath.replace(patternWithBSlashOnly, destinationLanguage);
  } else {
    newPath = destinationLanguage;
  }

  return newPath;
};

const GlobalHeader = (props) => {
  const isEditing = props.sitecoreContext && props.sitecoreContext.pageEditing;

  const utilityLinksFolderItemId = props.fields?.utilityfolder?.id;
  const utilityLinksFolder = props.fields?.children?.find((e) => e.id === utilityLinksFolderItemId);

  const myRotary = props.fields?.myrotary;

  const signInMenu = utilityLinksFolder?.fields?.children.find((e) => e.id === '2f1bbf0b-9713-48f2-9c18-4637b7ba3809');

  const registerMenu = utilityLinksFolder?.fields?.children.find((e) => e.id === 'fe603326-0810-4d7c-a6c4-03cbe1c43955');

  const languagesFolder = utilityLinksFolder?.fields?.children.find((e) => e.templateId === '4c16618d-2e55-477f-add7-f11a7956a17e');
  const langaugeLinks = [];
  const languages = languagesFolder?.fields?.children;
  languages?.map((link, i) => {
    langaugeLinks.push(
      <>
        <RoutableLink field={getLanguageLink(link.fields?.link)} key={i} data-langid={`${link.fields?.language?.id}`} useATag={true}>
          <WBRString tag="span">
            <Text field={link.fields?.linktext} />
          </WBRString>
        </RoutableLink>
      </>
    );
  });
  const selectedLang = languages?.find((l) => l.fields?.language?.name === props.sitecoreContext?.language);
  const otherLinksFolderItemId = props.fields?.otherlinkfolder?.id;
  const otherLinksFolder = props.fields?.children?.find((e) => e.id === otherLinksFolderItemId);
  const otherLinks = [];
  otherLinksFolder?.fields?.children?.map((link, i) => {
    if (link?.fields?.HideMenu?.value !== true) {
      otherLinks.push(
        <>
          <li id="other_links_id" className="otherlink">
            <RoutableLink field={link.fields?.link} key={i} useATag={true} className={link?.fields?.AddClass?.value}>
              <WBRString tag="span">
                <Text field={link.fields?.linktext} />
              </WBRString>
            </RoutableLink>
            {/* <EditableLink linkField={link.fields?.link} isEditing={isEditing} /> */}
          </li>
        </>
      );
    }
  });
  const primaryLinksList = props.fields?.children;
  const primaryLinksListFolder = primaryLinksList?.find((e) => e.templateId === 'a4bab5b6-4c0d-4fb5-8d86-2b47507221bc');
  const primaryLinks = [];
  primaryLinksListFolder?.fields?.children?.map((link, i) => {
    primaryLinks.push(link);
  });
  const mainLinksList = primaryLinksListFolder?.fields?.children?.filter((e) => e.fields?.otherlink?.value === false);
  const mainNav = [];
  mainLinksList?.map((link, i) => {
    const linklist = getLinkList(link);
    if (link?.fields?.hideLink?.value === true) {
      return;
    }
    mainNav.push({
      label: <Text field={link?.fields?.linktext} />,
      href: link?.fields?.link.value?.href,
      id: i,
      options: {
        linkOption: linklist?.length !== 0,
        linkOptionTitle: getLinkListTitle(link),
        linkRichText: getLinkRichtext(link),
        optionLinks: linklist,
        Left: getMenuCards(link, 'left', 'button primary'),
        Right: getMenuCards(link, 'right', 'button secondary'),
      },
    });
  });

  const otherLinksList = primaryLinksListFolder?.fields?.children?.filter((e) => e.fields?.otherlink?.value === true);
  const navRightInfo = [];
  otherLinksList?.map((link, i) => {
    if (link.fields?.otherlinktype?.fields?.Value?.value === 'onlybutton') {
      navRightInfo.push(
        <>
          {link?.fields?.linktext && link?.fields?.linktext?.value ? (
            <RoutableLink field={link?.fields?.link} key={i} useATag={true}>
              <button className="button_bg_white">
                <WBRString tag="span">
                  <Text field={link?.fields?.linktext} />
                </WBRString>
              </button>
            </RoutableLink>
          ) : null}
        </>
      );
    } else {
      navRightInfo.push(
        <>
          <RoutableLink field={link?.fields?.link} key={i} useATag={true}>
            <WBRString tag="span" class="nav_cta_text">
              <Text field={link?.fields?.linktext} />
            </WBRString>
            <button className="button_border">{i18n.t('button/view') || 'View'}</button>
          </RoutableLink>
        </>
      );
    }
  });

  return (
    <>
      <Header
        logoName={<Text field={props?.fields?.sitename} />}
        myRotaryLink={
          <>
            <RoutableLink field={myRotary?.fields?.link} useATag={true}>
              <img src={homeIcon} width="15" height="11" />
              <WBRString tag="span">
                <Text field={myRotary?.fields?.linktext} />
              </WBRString>
            </RoutableLink>
            <EditableLink linkField={myRotary?.fields?.link} isEditing={isEditing} />
          </>
        }
        signInLink={
          signInMenu && (
            <>
              <RoutableLink field={signInMenu?.fields?.link} useATag={true}>
                <WBRString tag="span">
                  <Text field={signInMenu?.fields?.linktext} />
                </WBRString>
              </RoutableLink>
              <EditableLink linkField={signInMenu?.fields?.link} isEditing={isEditing} />
            </>
          )
        }
        registerLink={
          registerMenu && (
            <>
              <RoutableLink field={registerMenu?.fields?.link} useATag={true}>
                <WBRString tag="span">
                  <Text field={registerMenu?.fields?.linktext} />
                </WBRString>
              </RoutableLink>
              <EditableLink linkField={registerMenu?.fields?.link} isEditing={isEditing} />
            </>
          )
        }
        logo={
          <>
            <RoutableLink field={props?.fields?.logolink} useATag={true}>
              <span className="logo">
                <Image
                  field={props?.fields?.logoimage}
                  editable={true}
                  imageParams={{ mw: 116, mh: 44 }}
                  height={44}
                  width={116}
                  data-sample="other-attributes-pass-through"
                />
              </span>
              {props.fields?.sitelogo?.value?.src !== undefined ? (
                <Image
                  field={props.fields?.sitelogo}
                  editable={true}
                  imageParams={{ mw: 116, mh: 44 }}
                  height={44}
                  width={116}
                  data-sample="other-attributes-pass-through"
                />
              ) : (
                <WBRString tag="span" class="logo_text">
                  <Text field={props?.fields?.sitename} />
                </WBRString>
              )}
            </RoutableLink>
          </>
        }
        otherLinks={otherLinks}
        searchText={<Text field={props?.fields?.searchtext} />}
        searchPlaceholderText={props?.fields?.searchplaceholdertext?.value}
        languageList={langaugeLinks}
        languageSelected={selectedLang?.fields?.linktext?.value}
        menuText={<Text field={props?.fields?.hamburgermenutext} />}
        megaNavPlaceholder={props?.fields?.kioskheader?.value === true ? <></> : <MegaNav mainNav={mainNav} navRightInfo={navRightInfo} />}
        handleClick={() => {
          let value = document.getElementById('siteSearch').value;
          let searchTerm = <CoveoSearch query={value} />;
          let search = searchTerm.props.query;
          let url = '/search#';
          let query = url + 'q=' + search;
          if (search !== '' && search !== null) {
            location.href = query;
          }
        }}
        handleChange={(e) => {
          if (e.key === 'Enter') {
            let value = document.getElementById('siteSearch').value;
            let searchTerm = <CoveoSearch query={value} />;
            let search = searchTerm.props.query;
            let url = '/search#';
            let query = url + 'q=' + search;
            if (search !== '' && search !== null) {
              location.href = query;
            }
          }
        }}
        hideSearch={props.fields?.hidesearch?.value}
        kioskHeader={props?.fields?.kioskheader?.value}
      />
    </>
  );
};

export default withSitecoreContext()(GlobalHeader);
